import React from "react";
import {
  Box,
  Modal,
  Grid,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  ListItemText,
} from "@mui/material";
import GlobalButton from "../../shared/utils/GlobalButton.jsx";

const ProductsServicesModal = ({
  isOpen,
  formData,
  handleChange,
  handleClose,
  handleSubmit,
  isEditing,
}) => {
  // Multi-select options
  const fabricationTypes = [
    { value: "Glow Sign Boards", label: "Glow Sign Boards" },
    { value: "ACP Sign Board", label: "ACP Sign Board" },
    { value: "Lollipop Signage", label: "Lollipop Signage" },
    { value: "3D Signage", label: "3D Signage" },
    { value: "Flex Frame Signage", label: "Flex Frame Signage" },
    { value: "Aluminum Backlit Signage", label: "Aluminum Backlit Signage" },
  ];

  const PrintingTypes = [
    { value: "Solvent Print", label: "Solvent Print" },
    { value: "Eco Solvent Print", label: "Eco Solvent Print" },
    { value: "UV Printing", label: "UV Printing" },
    { value: "Latex Printing", label: "Latex Printing" },
    { value: "Plotter Cut", label: "Plotter Cut" },
    { value: "Vinyl Branding", label: "Vinyl Branding" },
  ];

  const PaintingTypes = [
    { value: "Wall painting", label: "Wall painting" },
    { value: "Shutter painting", label: "Shutter painting" },
  ];

  const isSubmitDisabled =
    formData?.fabrication == false &&
    formData?.printingProducts == false &&
    formData?.paintingProducts == false;

  return (
    <Modal open={isOpen}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: "auto" }, // Full width on mobile, auto for larger screens
          maxWidth: 500,
          bgcolor: "background.paper",
          borderRadius: "8px",
          boxShadow: 24,
          p: 4,
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Fabrication Products Checkbox */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.fabrication || false}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "fabrication",
                          value: e.target.checked,
                        },
                      })
                    }
                    name="fabrication"
                  />
                }
                label="Fabrication Products"
              />
            </Grid>

            {formData.fabrication && (
              <Grid item xs={12}>
                <InputLabel id="storeFrontSignages-select-label">
                  Select Fabrication Product:
                </InputLabel>
                <FormControl fullWidth>
                  <Select
                    labelId="storeFrontSignages-select-label"
                    id="storeFrontSignages-select"
                    multiple
                    value={formData.typesOfFabrication || []}
                    onChange={handleChange}
                    name="typesOfFabrication"
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {fabricationTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={formData.typesOfFabrication.includes(
                            option.value,
                          )}
                        />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {/* Printing Products Checkbox */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.printingProducts || false}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "printingProducts",
                          value: e.target.checked,
                        },
                      })
                    }
                    name="printingProducts"
                  />
                }
                label="Printing Products"
              />
            </Grid>

            {formData.printingProducts && (
              <Grid item xs={12}>
                <InputLabel id="print-select-label">
                  Select Printing Product:
                </InputLabel>
                <FormControl fullWidth>
                  <Select
                    labelId="print-select-label"
                    id="print-select"
                    multiple
                    value={formData.typesOfPrintingProducts || []}
                    onChange={handleChange}
                    name="typesOfPrintingProducts"
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {PrintingTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={formData.typesOfPrintingProducts.includes(
                            option.value,
                          )}
                        />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            {/* Painting Products Checkbox */}
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.paintingProducts || false}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "paintingProducts",
                          value: e.target.checked,
                        },
                      })
                    }
                    name="paintingProducts"
                  />
                }
                label="Painting Products"
              />
            </Grid>

            {formData.paintingProducts && (
              <Grid item xs={12}>
                <InputLabel id="print-select-label">
                  Select Painting Product:
                </InputLabel>
                <FormControl fullWidth>
                  <Select
                    labelId="print-select-label"
                    id="print-select"
                    multiple
                    value={formData.typesOfPaintingProducts || []}
                    onChange={handleChange}
                    name="typesOfPaintingProducts"
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {PaintingTypes.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox
                          checked={formData.typesOfPaintingProducts.includes(
                            option.value,
                          )}
                        />
                        <ListItemText primary={option.label} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>
          <Grid
            container
            spacing={2}
            sx={{
              mt: 2,
              justifyContent: "flex-end",
            }}
          >
            <Grid item>
              <GlobalButton
                variant="secondary"
                size="medium"
                onClick={handleClose}
              >
                {`Close`}
              </GlobalButton>
            </Grid>
            <Grid item>
              <GlobalButton
                type="submit"
                variant="primary"
                size="medium"
                disabled={isSubmitDisabled}
              >
                {isEditing ? "Update" : "Save"}
              </GlobalButton>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
};

export default ProductsServicesModal;
